export * from './standorts-list.component';
export * from './standorts-list.component.module';